import secureApi from '../../utils/secureApi';

export async function deleteWeeklyReport(id: string) {
  const response = await secureApi.post<any>(
    `/api/v2/tournaments/admin/weeklyReports/delete?_id=${id}`,
    {}
  );
  
  // secureApi returns response.data automatically
  // Handle API response structure: may be wrapped in { statusCode, data: {...} } or direct
  if (response && response.data) {
    return response.data; // Wrapped in data field
  }
  return response; // Fallback
} 